<template>
  <div>
    <b-row
      v-for="(item, index) in items"
      :key="`loading-${index}`"
      class="margin-0 padding-16 border--solid border--complementary-50 border-radius-8 margin-bottom-8"
    >
      <b-col cols="12" class="padding-0 margin-bottom-16">
        <b-skeleton width="80%"></b-skeleton>
      </b-col>
      <b-col cols="12" class="padding-0 flex-start margin-bottom-8">
        <b-skeleton type="button" class="width-24 height-24"></b-skeleton>
        <b-skeleton width="50%" class="margin-right-8"></b-skeleton>
      </b-col>
      <b-col cols="12" class="padding-0">
        <b-skeleton width="80%"></b-skeleton>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    count: {
      type: Number,
      default: 6,
    },
  },
  computed: {
    items() {
      const arr = [];
      arr.length = this.count;
      arr.fill("empty");
      return arr;
    },
  },
};
</script>
